var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186542_41760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.73828H11.8125V4.96328C11.8125 4.68672 11.5891 4.46328 11.3125 4.46328H6.39062L4.55781 2.71016C4.53449 2.68832 4.50382 2.67606 4.47188 2.67578H0.5C0.223437 2.67578 0 2.89922 0 3.17578V12.4258C0 12.7023 0.223437 12.9258 0.5 12.9258H11.4062C11.6094 12.9258 11.7937 12.8023 11.8703 12.6133L13.9641 7.42578C13.9875 7.36641 14 7.30234 14 7.23828C14 6.96172 13.7766 6.73828 13.5 6.73828ZM1.125 3.80078H4.07031L5.93906 5.58828H10.6875V6.73828H2.71875C2.51562 6.73828 2.33125 6.86172 2.25469 7.05078L1.125 9.85078V3.80078ZM11.0516 11.8008H1.48438L3.09844 7.80078H12.6672L11.0516 11.8008Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186542_41760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.800781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.b8379a045f17f56252271fa1c7cb34ae.svg";
export { ForwardRef as ReactComponent };